function polygonAreaInMeters(coordinates) {
  const R = 6378137; // radio de la Tierra en metros
  let area = 0;

  const ring = coordinates[0]; // primer anillo del polígono

  for (let i = 0; i < ring.length - 1; i++) {
    const [lon1, lat1] = ring[i];
    const [lon2, lat2] = ring[i + 1];

    area += (toRadians(lon2) - toRadians(lon1)) *
            (2 + Math.sin(toRadians(lat1)) + Math.sin(toRadians(lat2)));
  }

  area = area * R * R / 2;
  return Math.abs(area); // en m²
}

function toRadians(deg) {
  return deg * Math.PI / 180;
}

function getLargestPolygonArea(geojson) {
  let maxArea = 0;

  for (const feature of geojson.features) {
    const geom = feature.geometry;
    if (geom.type === 'Polygon') {
      const area = polygonAreaInMeters(geom.coordinates);
      if (area > maxArea) maxArea = area;
    } else if (geom.type === 'MultiPolygon') {
      for (const poly of geom.coordinates) {
        const area = polygonAreaInMeters(poly);
        if (area > maxArea) maxArea = area;
      }
    }
  }

  return Math.round(maxArea / 10000); // en hectáreas
}

export { polygonAreaInMeters, getLargestPolygonArea };